import React from 'react';

export default function Services() {
  return (
    <section>
        <h2>Services</h2>
        <ul>
            <li>
                {" "}
                <h3>Graphic Design</h3>{" "}
            </li>
            <li>
                <h3>Web development </h3>{" "}
            </li>
            <li>
                <h3>Computer Vision </h3>{" "}
            </li>
            <li>
                <h3>SEO </h3>{" "}
            </li>
            <li>
                <h3>Google Ads </h3>{" "}
            </li>
            <li>
                <h3>Lead Management </h3>{" "}
            </li>
            <li>
                <h3>UI/UX Design </h3>{" "}
            </li>
        </ul>   
    </section>
  );
}
